module.exports = __webpack_public_path__ + "img/sent.61bd7d8a.svg";